import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { 
  FiHome, FiUsers, FiCalendar, FiBarChart3, FiSettings, FiUser, FiLogOut,
  FiActivity, FiChevronLeft, FiChevronRight
} = FiIcons;

const Sidebar = ({ 
  activeSection, 
  setActiveSection, 
  isCollapsed, 
  setIsCollapsed, 
  onLogout 
}) => {
  const menuItems = [
    { id: 'overview', label: 'Overview', icon: FiHome },
    { id: 'appointments', label: 'Appointments', icon: FiCalendar },
    { id: 'team', label: 'Team Management', icon: FiUsers },
    { id: 'analytics', label: 'Analytics', icon: FiBarChart3 },
    { id: 'profile', label: 'Profile', icon: FiUser }
  ];

  return (
    <motion.div
      initial={{ x: -250 }}
      animate={{ x: 0, width: isCollapsed ? 80 : 250 }}
      transition={{ duration: 0.3 }}
      className="bg-white border-r border-gray-200 flex flex-col shadow-lg relative"
    >
      {/* Header */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          {!isCollapsed && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="flex items-center space-x-3"
            >
              <div className="h-8 w-8 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-lg flex items-center justify-center">
                <SafeIcon icon={FiActivity} className="h-5 w-5 text-white" />
              </div>
              <div>
                <h2 className="font-bold text-gray-900 text-sm">Best Podiatrist</h2>
                <p className="text-xs text-gray-500">Admin Dashboard</p>
              </div>
            </motion.div>
          )}
          
          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <SafeIcon 
              icon={isCollapsed ? FiChevronRight : FiChevronLeft} 
              className="h-4 w-4 text-gray-500" 
            />
          </button>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4">
        <div className="space-y-2">
          {menuItems.map((item) => (
            <motion.button
              key={item.id}
              onClick={() => setActiveSection(item.id)}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className={`w-full flex items-center ${
                isCollapsed ? 'justify-center' : 'justify-start'
              } space-x-3 px-3 py-3 rounded-lg transition-all duration-200 ${
                activeSection === item.id
                  ? 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white shadow-md'
                  : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
              }`}
              title={isCollapsed ? item.label : undefined}
            >
              <SafeIcon icon={item.icon} className="h-5 w-5 flex-shrink-0" />
              {!isCollapsed && (
                <span className="font-medium text-sm">{item.label}</span>
              )}
            </motion.button>
          ))}
        </div>
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-gray-200">
        <motion.button
          onClick={onLogout}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className={`w-full flex items-center ${
            isCollapsed ? 'justify-center' : 'justify-start'
          } space-x-3 px-3 py-3 rounded-lg text-red-600 hover:bg-red-50 transition-colors`}
          title={isCollapsed ? 'Logout' : undefined}
        >
          <SafeIcon icon={FiLogOut} className="h-5 w-5 flex-shrink-0" />
          {!isCollapsed && (
            <span className="font-medium text-sm">Logout</span>
          )}
        </motion.button>
      </div>
    </motion.div>
  );
};

export default Sidebar;